import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'

import { System } from '@leverege/api-redux'
import { ResourceUsersScreen } from '@leverege/api-ui-user-management'

class SystemUsersScreen extends React.Component {

  render() {
    const { params } = this.props.match
    const { projectId, systemId : resourceId } = params
    return (
      <ResourceUsersScreen
        allowApiAccess
        selectorProps={{ simple : false }} 
        projectId={projectId} 
        resourceId={resourceId}
        systemId={resourceId}
        actions={System( resourceId )}/>
    )
  }
} 

export default connect(
  state => ( {
    
  } )
)( SystemUsersScreen );
